/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Faq_A2Inputs */

const en_formatter_faq_a2 = /** @type {(inputs: Formatter_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Values are preserved, but the text of numbers is regenerated. 1.0 is written as 1 and 1e3 as 1000, which parse to the same values. Integers beyond 2^53 are the exception and do lose precision.`)
};

const ko_formatter_faq_a2 = /** @type {(inputs: Formatter_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`값은 보존되지만 숫자의 표기는 다시 생성됩니다. 1.0은 1로, 1e3은 1000으로 쓰이며 둘 다 같은 값으로 파싱됩니다. 2^53을 넘는 정수는 예외로 실제로 정밀도를 잃습니다.`)
};

const ja_formatter_faq_a2 = /** @type {(inputs: Formatter_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値は保たれますが、数値の表記は再生成されます。1.0 は 1、1e3 は 1000 と書かれ、どちらも同じ値にパースされます。2^53 を超える整数は例外で、実際に精度を失います。`)
};

/**
* | output |
* | --- |
* | "Values are preserved, but the text of numbers is regenerated. 1.0 is written as 1 and 1e3 as 1000, which parse to the same values. Integers beyond 2^53 are t..." |
*
* @param {Formatter_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_faq_a2 = /** @type {((inputs?: Formatter_Faq_A2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Faq_A2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_faq_a2(inputs)
	if (locale === "ko") return ko_formatter_faq_a2(inputs)
	return ja_formatter_faq_a2(inputs)
});